// import { TextField, MenuItem, Button } from "@mui/material";
// import { useContext, useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import { CompanyInformationFinepModel, LegalEntityRegistrationFinepModel } from "../../../../Models/LegalEntityRegistrationFinepModel";
// import { countries } from "../../../../Static/Countries";
// import { CreateLegalEntityFinep, EditLegalEntityFinep, GetLegalEntityFinep, ValidateLegalEntityFinep } from "../../../../API/LegalEntityRegistrationFinepAPI";
// import Loader from "../../../../Components/Shared/Loader";
// import { useParams } from "react-router-dom";
// import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
// import { useAuth } from "../../../../Hooks/useAuth";
// import { CreateCompanyInformationFinep } from "../../../../API/CompanyInformationFinepAPI";

// const LegalEntityRegistrationFinepTab = () => {
//     const [loading, setLoading] = useState(false);
//     const [validateField, setValidateField] = useState(false);
//     const [cnpj, setCNPJ] = useState("");
//     const [razaoSocial, setRazaoSocial] = useState("");
//     const [companiesInformation, setCompaniesInformation] = useState<CompanyInformationFinepModel[]>([]);
//     const [role, setRole] = useState("");
//     const [legalEntityId, setLegalEntityId] = useState("");
//     const [countryOfController, setCountryOfController] = useState("");
//     const { companyId, registerId } = useParams();
//     const { changeTab, handleFillTab, handleValidateTab, handleInvalidateTab } = useContext(CompanyFinepContext);

//     const user = useAuth();

//     async function handleAddRegistration() {
//         setLoading(true);

//         if (cnpj === "") {
//             toast.error("Preencha o campo CNPJ para continuar");
//             return;
//         }

//         if (razaoSocial === "") {
//             toast.error("Preencha o campo Razão Social para continuar");
//             return;
//         }

//         const companyRegistration: CompanyInformationFinepModel = {
//             cnpj: cnpj,
//             corporateName: razaoSocial
//         }

//         await CreateCompanyInformationFinep({
//             cnpj: cnpj,
//             corporateName: razaoSocial,
//             legalEntityRegistrationFINEPId: legalEntityId,
//             userEmail: user.userEmail
//         }).catch(x => setLoading(false));

//         handleFillTab(3);

//         setCompaniesInformation([...companiesInformation, companyRegistration])
//         setCNPJ("");
//         setRazaoSocial("");

//         setLoading(false);
//     }

//     async function getLegalEntity() {
//         setLoading(true);

//         if (companyId) {
//             await GetLegalEntityFinep(companyId)
//                 .then(x => {
//                     const legalEntity: LegalEntityRegistrationFinepModel = x.legalEntityRegistrationFINEP;

//                     if (legalEntity) {
//                         handleFillTab(3);

//                         if (legalEntity.isContentValid) {
//                             handleValidateTab(3, 2);
//                             setValidateField(true);
//                         }

//                         setCountryOfController(legalEntity.countryOfController);
//                         setLegalEntityId(legalEntity.id ?? "");
//                         setRole(legalEntity.role);

//                     }

//                     if (x.companyInformationFINEP.length > 0)
//                         handleFillTab(3);

//                     setCompaniesInformation(x.companyInformationFINEP);
//                 }).catch(x => setLoading(false));
//         }
//         setLoading(false);
//     }

//     async function submitLegalEntity() {
//         setLoading(true);

//         const legalEntity: LegalEntityRegistrationFinepModel = {
//             userEmail: user.userEmail,
//             countryOfController: countryOfController,
//             companyFINEPId: companyId,
//             role: role,
//             isContentValid: validateField,
//         }

//         if (legalEntityId != "" && legalEntity != undefined) {
//             legalEntity.id = legalEntityId;

//             await EditLegalEntityFinep(legalEntity)
//                 .catch(x => setLoading(false));
//         }
//         else {

//             handleFillTab(3);

//             await CreateLegalEntityFinep(legalEntity)
//                 .then((x: any) => {

//                     setLegalEntityId(x.data.id);
//                 })
//                 .catch((x: any) => setLoading(false));
//         }
//         setLoading(false);
//     }

//     async function handleValidate(isValid: boolean) {
//         setLoading(true);

//         setValidateField(isValid);

//         await ValidateLegalEntityFinep({
//             id: legalEntityId,
//             isContentValid: isValid,
//             userEmail: user.userEmail
//         }).then(x => {
//             if (isValid) {
//                 handleValidateTab(3, 2);
//             }
//             else {
//                 handleInvalidateTab(3, 2);
//             }
//         }).catch(x => setLoading(false));

//         setLoading(false);
//     }

//     useEffect(() => {
//         getLegalEntity();
//     }, [])

//     return (
//         <>
//             {loading && <Loader />}
//             <TabsHeader
//                 canValidate={true}
//                 valueSelected={validateField}
//                 changeValidate={handleValidate}
//                 registerId={registerId}
//                 cardName="Pessoa Jurídica"
//                 tabName="Grupo Econômico"
//             />
//             <h4 className="mt-4">
//                 <strong className="blue">Cadastro Pessoa Jurídica - Proponente ou Executora</strong>
//             </h4>
//             <p className="gray">Informações primárias da empresa</p>
//             <div className="d-flex mt-4">
//                 <TextField
//                     type="text"
//                     label="A pessoa Jurídica é:"
//                     className="w-100 me-4"
//                     select
//                     onChange={e => setRole(e.target.value)}
//                     value={role}
//                     onBlur={submitLegalEntity}
//                     defaultValue=""
//                 >
//                     <MenuItem value="">Escolha um valor</MenuItem>
//                     <MenuItem value="Independente">Independente</MenuItem>
//                     <MenuItem value="Parte de um Grupo">Parte de um Grupo</MenuItem>
//                 </TextField>
//                 <TextField
//                     type="text"
//                     label="País onde se encontra a controladora do grupo"
//                     className="w-100"
//                     onChange={e => setCountryOfController(e.target.value)}
//                     value={countryOfController}
//                     onBlur={submitLegalEntity}
//                     select
//                     defaultValue=""
//                 >
//                     <MenuItem value="">Escolha um valor</MenuItem>
//                     {countries.map((country, index) => {
//                         return (
//                             <MenuItem key={index} value={country}>{country}</MenuItem>
//                         )
//                     })}
//                 </TextField>
//             </div>
//             <strong className="d-block mt-4 mb-4">Empresas do Grupo com Relacionamento com a FINEP</strong>
//             <table className="table table-bordered table-hover">
//                 <thead>
//                     <tr>
//                         <th>
//                             <strong className="blue">CNPJ</strong>
//                         </th>
//                         <th>
//                             <strong className="blue">Razão de Social</strong>
//                         </th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {companiesInformation.map((company, index) => {
//                         return (
//                             <tr key={index}>
//                                 <td>{company.cnpj}</td>
//                                 <td>{company.corporateName}</td>
//                             </tr>
//                         )
//                     })}
//                 </tbody>
//             </table>
//             <div className="d-flex mt-4">
//                 <TextField
//                     type="text"
//                     label="CNPJ"
//                     className="w-100 me-4"
//                     value={cnpj}
//                     onChange={(e) => setCNPJ(e.target.value)}
//                 />
//                 <TextField
//                     type="text"
//                     label="Razão Social"
//                     className="w-100"
//                     value={razaoSocial}
//                     onChange={(e) => setRazaoSocial(e.target.value)}
//                 />
//             </div>
//             <div className="mt-4 mb-4 d-flex justify-content-end">
//                 <Button disabled={legalEntityId ? false : true} variant="contained" type="button" onClick={handleAddRegistration}>
//                     + Adicionar Empresa
//                 </Button>
//             </div>
//             <div className="d-flex justify-content-end mt-4 mb-4">
//                 <Button variant="contained" className="me-4" type="button" onClick={() => changeTab(4)}>Próxima Etapa</Button>
//                 <Button variant="outlined" className="" type="button" onClick={() => changeTab(2)}>Voltar</Button>
//             </div>
//         </>
//     )
// };

// export default LegalEntityRegistrationFinepTab







import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Button, Select, Form, Table, Typography, Space, Popconfirm } from "antd";
import { PlusCircleOutlined, EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import {
    CreateLegalEntityFinep,
    EditLegalEntityFinep,
    GetLegalEntityFinep,
    ValidateLegalEntityFinep,
} from "../../../../API/LegalEntityRegistrationFinepAPI";
import Loader from "../../../../Components/Shared/Loader";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
import { useAuth } from "../../../../Hooks/useAuth";
import { CompanyInformationFinepModel, LegalEntityRegistrationFinepModel } from "../../../../Models/LegalEntityRegistrationFinepModel";
import { countries } from "../../../../Static/Countries";

const { Option } = Select;
const { Title, Text } = Typography;
interface TableCompanyInfo extends CompanyInformationFinepModel {
    id: string;
}
const LegalEntityRegistrationFinepTab = () => {
    const [loading, setLoading] = useState(false);
    const [validateField, setValidateField] = useState(false);
    const [companiesInformation, setCompaniesInformation] = useState<TableCompanyInfo[]>([]);
    const [editingId, setEditingId] = useState<string | null>(null);
    const [role, setRole] = useState("");
    const [legalEntityId, setLegalEntityId] = useState("");
    const [countryOfController, setCountryOfController] = useState("");
    const { companyId, registerId } = useParams();
    const { changeTab, handleFillTab, handleValidateTab, handleInvalidateTab } = useContext(CompanyFinepContext);
    const user = useAuth();

    const [newCompany, setNewCompany] = useState({
        cnpj: "",
        corporateName: ""
    });

    const handleInputChange = (field: keyof typeof newCompany, value: string) => {
        setNewCompany(prev => ({ ...prev, [field]: value }));
    };

    const handleEditInputChange = (id: string, field: keyof TableCompanyInfo, value: string) => {
        setCompaniesInformation(prev =>
            prev.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    async function handleAddCompany() {
        if (!newCompany.cnpj || !newCompany.corporateName) {
            toast.error("Preencha todos os campos obrigatórios");
            return;
        }
        setLoading(true);
        try {
            const newId = `temp-${Math.random().toString(36).substr(2, 9)}`;
            const newCompanyInfo: TableCompanyInfo = {
                cnpj: newCompany.cnpj,
                corporateName: newCompany.corporateName,
                id: newId,
                legalEntityRegistrationFINEPId: legalEntityId,
                userEmail: user.userEmail
            };
            setCompaniesInformation([...companiesInformation, newCompanyInfo]);
            setNewCompany({ cnpj: "", corporateName: "" });
            toast.success("Empresa adicionada com sucesso!");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao adicionar empresa");
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (id: string) => {
        setEditingId(id);
    };

    const handleCancelEdit = () => {
        setEditingId(null);
    };

    const handleSave = async (id: string) => {
        try {
            setLoading(true);
            setEditingId(null);
            toast.success("Empresa atualizada com sucesso!");
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id: string) => {
        setLoading(true);
        try {
            setCompaniesInformation(companiesInformation.filter(item => item.id !== id));
            toast.success("Empresa removida com sucesso!");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao remover empresa");
        } finally {
            setLoading(false);
        }
    };

    async function getLegalEntity() {
        setLoading(true);
        if (companyId) {
            try {
                const response = await GetLegalEntityFinep(companyId);
                const legalEntity: LegalEntityRegistrationFinepModel = response.legalEntityRegistrationFINEP;
                if (legalEntity) {
                    handleFillTab(3);
                    if (legalEntity.isContentValid) {
                        handleValidateTab(3, 2);
                        setValidateField(true);
                    }
                    setCountryOfController(legalEntity.countryOfController);
                    setLegalEntityId(legalEntity.id ?? "");
                    setRole(legalEntity.role);
                }
                if (response.companyInformationFINEP?.length > 0) {
                    handleFillTab(3);
                    setCompaniesInformation(response.companyInformationFINEP);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    }

    async function submitLegalEntity() {
        setLoading(true);
        const legalEntity: LegalEntityRegistrationFinepModel = {
            userEmail: user.userEmail,
            countryOfController: countryOfController,
            companyFINEPId: companyId,
            role: role,
            isContentValid: validateField,
        };
        try {
            if (legalEntityId) {
                legalEntity.id = legalEntityId;
                await EditLegalEntityFinep(legalEntity);
            } else {
                const response = await CreateLegalEntityFinep(legalEntity);
                setLegalEntityId(response.data.id);
                handleFillTab(3);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleValidate(isValid: boolean) {
        setLoading(true);
        setValidateField(isValid);
        try {
            await ValidateLegalEntityFinep({
                id: legalEntityId,
                isContentValid: isValid,
                userEmail: user.userEmail
            });
            if (isValid) {
                handleValidateTab(3, 2);
            } else {
                handleInvalidateTab(3, 2);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getLegalEntity();
    }, []);
    useEffect(() => {
        setNewCompany(prev => ({
            ...prev,
            legalEntityRegistrationFINEPId: legalEntityId,
            userEmail: user.userEmail
        }));
    }, [legalEntityId, user.userEmail]);

    const columns = [
        {
            title: 'CNPJ',
            dataIndex: 'cnpj',
            key: 'cnpj',
            width: '40%',
            render: (text: string, record: TableCompanyInfo) => {
                if (record.id === editingId) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Input
                                value={text}
                                onChange={(e) => handleEditInputChange(record.id, 'cnpj', e.target.value)}
                            />
                        </Form.Item>
                    );
                }
                return <span>{text}</span>;
            },
        },
        {
            title: 'Razão Social',
            dataIndex: 'corporateName',
            key: 'corporateName',
            width: '40%',
            render: (text: string, record: TableCompanyInfo) => {
                if (record.id === editingId) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Input
                                value={text}
                                onChange={(e) => handleEditInputChange(record.id, 'corporateName', e.target.value)}
                            />
                        </Form.Item>
                    );
                }
                return <span>{text}</span>;
            },
        },
        {
            title: 'Ações',
            key: 'actions',
            width: '20%',
            align: 'center' as const,
            render: (_: any, record: TableCompanyInfo) => {
                if (record.id === editingId) {
                    return (
                        <Space size="middle">
                            <Button
                                type="primary"
                                onClick={() => handleSave(record.id)}
                                icon={<SaveOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                            <Button
                                onClick={handleCancelEdit}
                                icon={<CloseOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                        </Space>
                    );
                }
                return (
                    <Space size="middle">
                        <Button
                            onClick={() => handleEdit(record.id)}
                            icon={<EditOutlined />}
                            style={{ border: 'none', boxShadow: 'none' }}
                        />
                        <Popconfirm
                            title="Tem certeza que deseja excluir esta empresa?"
                            onConfirm={() => handleDelete(record.id)}
                            okText="Sim"
                            cancelText="Não"
                        >
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];

    return (
        <>
            {loading && <Loader />}
            <TabsHeader
                canValidate={true}
                valueSelected={validateField}
                changeValidate={handleValidate}
                registerId={registerId}
                cardName=""
                tabName=""
            />
            <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Cadastro Pessoa Jurídica - Proponente ou Executora</Title>
            <Text style={{ color: '#777777', fontSize: '18px', fontWeight: 'normal' }}>Informações primárias da empresa</Text>
            <div className="d-flex mt-4" style={{ gap: '16px' }}>
                <div style={{ flex: 1 }}>
                    <Text style={{ fontFamily: 'Century Gothic', fontWeight: 'normal' }}>A pessoa Jurídica é:</Text>
                    <Select
                        value={role}
                        onChange={(value) => {
                            setRole(value);
                            submitLegalEntity();
                        }}
                        placeholder="Escolha um valor"
                        style={{ width: '100%', marginTop: 8 }}
                    >
                        <Option value="">Escolha um valor</Option>
                        <Option value="Independente">Independente</Option>
                        <Option value="Parte de um Grupo">Parte de um Grupo</Option>
                    </Select>
                </div>
                <div style={{ flex: 1 }}>
                    <Text style={{ fontFamily: 'Century Gothic', fontWeight: 'normal' }}>País onde se encontra a controladora do grupo:</Text>
                    <Select
                        value={countryOfController}
                        onChange={(value) => {
                            setCountryOfController(value);
                            submitLegalEntity();
                        }}
                        placeholder="Escolha um valor"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            if (option?.children) {
                                return String(option.children).toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }}
                        style={{ width: '100%', marginTop: 8 }}
                    >
                        <Option value="">Escolha um valor</Option>
                        {countries.map((country, index) => (
                            <Option key={index} value={country}>{country}</Option>
                        ))}
                    </Select>
                </div>
            </div>
            <Title level={5} className="mt-4 mb-4">
                <Text style={{ fontFamily: 'Century Gothic', fontWeight: 'normal' }}>Empresas do Grupo com Relacionamento com a FINEP:</Text>
            </Title>
            <Table
                columns={columns}
                dataSource={companiesInformation}
                rowKey={(record) => record.id}
                bordered
                pagination={false}
                style={{ marginBottom: 24 }}
                locale={{
                    emptyText: 'Nenhum dado diponível'
                }}
                footer={() => (
                    <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
                        <Input
                            value={newCompany.cnpj}
                            onChange={(e) => handleInputChange('cnpj', e.target.value)}
                            placeholder="Digite o CNPJ"
                            style={{ padding: '4px 8px', width: '40%' }}
                        />
                        <Input
                            value={newCompany.corporateName}
                            onChange={(e) => handleInputChange('corporateName', e.target.value)}
                            placeholder="Digite a Razão Social"
                            style={{ padding: '4px 8px', width: '40%' }}
                        />
                        <Button
                            type="primary"
                            onClick={handleAddCompany}
                            icon={<PlusCircleOutlined />}
                            disabled={!legalEntityId || !newCompany.cnpj || !newCompany.corporateName}
                        >
                            Adicionar
                        </Button>
                    </div>
                )}
            />
            <div className="d-flex justify-content-end mt-4 mb-4">
                <Button className="me-4" onClick={() => changeTab(2)}>Voltar</Button>
                <Button type="primary" onClick={() => changeTab(4)}><PlusOutlined /> Próxima Etapa</Button>
            </div>
        </>
    );
};
export default LegalEntityRegistrationFinepTab;